interface Collection {
  id: string;
  name: string;
}

export const findCollection = (collections: Collection[], id: string): Collection | null =>
  collections.find((c) => c.id === id) || null;

export default Collection;
